<template>
  <div
    class="check-list-phone auto-list_col_centered price-load-day"
    @click.stop
  >
    <el-row type="flex" align="middle" justify="center">
      <div class="fs-14">
        <p v-if="type !== 'harvest'">
          <template v-if="isTudatka">
            {{ response.price_from_storage_driver }}&nbsp;руб за рейс
          </template>
          <template v-else>
            {{ response.price_from_storage_driver | getPrice }}
            <span v-if="type === 'harvest_or_delivery'"> (П), </span>
          </template>
        </p>
        <p v-if="type !== 'delivery'">
          {{ response.price_from_field_driver | getPrice }}
          <span v-if="type === 'harvest_or_delivery'"> (У) </span>
        </p>
      </div>
      <div v-if="canAction('editResponsePrice')">
        <i class="el-icon-edit edit-price-ld-i" @click="$emit('open')" />
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Price',
  props: {
    response: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
    isTudatka: {
      type: Number,
      default: 0,
    },
  },
}
</script>
